export default __webpack_public_path__ + "static/media/Arvind.6607f727.png";